export default "__VITE_ASSET__DNZqMBuK__"